module.exports = __webpack_public_path__ + "img/2026-03-24c_2.9c7bc0b8.jpg";